<script>
    // import Carousel from "../../../Components/Carousel/Carousel.svelte";
    import Button from "../../../Components/Button/Button.svelte";
    import { User, getNews, request, russianMonths } from "../../../store";

    import TextArrow from "../../../Components/TextArrow/TextArrow.svelte";
    import pattern_2 from "../../../../public/src/svg/Patterns/pattern_2.svelte";

    let user;
    let showContent = false;
    let news = [];
    let images;
    let carouselShow = false;
    let id =
        window.location.href.split("/")[
            window.location.href.split("/").length - 1
        ];
    User.subscribe((value) => {
        user = value;
    });

    function addNews() {
        window.location.pathname = "/news/add";
    }

    function editNews() {
        window.location.pathname = "/news/edit" + id;
    }

    function deleteNews() {
        request("/news/delete/" + id, "POST", "").then((response) => {
            if (response || response == 0) {
                window.location.pathname = "/news";
            }
        });
    }

    getNews("/news/get/" + id).then((response) => {
        news = response[0];
        images = news[6];
        if (images[0] != "") {
            carouselShow = true;
        }
        showContent = true;
    });

    function getFormatedDate(myDate) {
        let date = new Date(myDate);
        return `${date?.getDate()} ${
            russianMonths[date?.getMonth()]
        } ${date?.getFullYear()}`;
    }
</script>

<div id="content" class:invisible={!showContent}>
    <div class="pattern-block" style="margin-bottom: 20px;">
        <div class="pattern">
            <svelte:component this={pattern_2} />
        </div>
    </div>
    <TextArrow showArrow={false} text={news[2]} />

    {#if user?.role == "1"}
        <div class="buttons">
            <Button on:click={editNews}>Редактировать</Button>
            <Button on:click={deleteNews}>Удалить</Button>
        </div>
    {/if}
    <div class="news">
        <div class="news-banner">
            <img src={news[5]} alt="" />
        </div>
        <div class="news-body">
            <div class="small" style="margin: 5px; opacity: 0.8;">
                {getFormatedDate(news[8])}
            </div>
            <div class="news-content">
                {@html news[4]}
            </div>
            <!-- {#if carouselShow}
                <div class="carousel-preview">
                    <Carousel {images} />
                </div>
            {/if} -->
        </div>
    </div>
</div>

<style lang="less" global>
    @import "./news.less";
</style>
